export default __webpack_public_path__ + "static/media/gengaar.13bd3793.png";